import React, { useState } from 'react';
import { Star, X } from 'lucide-react';
import { API_URL } from './constants';

const FeedbackModal = ({
  user,
  open = false,
  onClose,
  title = "Quick Feedback",
  subtitle = "How is your experience with DataCreator AI?"
}) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleFeedbackSubmit = async () => {
    setSubmitted(true);
    try {
      var feedbackData = {
        user_id: user ? user.uid : 'anonymous',
        rating: rating,
        feedback: feedback
      };

      const headers = {
        'Content-Type': 'application/json'
      };
      if (user && user.accessToken) {
        headers['Authorization'] = `Bearer ${user.accessToken}`;
      }

      await fetch(`${API_URL}/api/submit-feedback`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(feedbackData)
      });
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  const handleClose = () => {
    setRating(0);
    setFeedback('');
    setSubmitted(false);
    if (onClose) onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[70]">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>

        {!submitted ? (
          <div className="space-y-6">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
              <p className="mt-2 text-gray-600">{subtitle}</p>
            </div>

            <div className="flex justify-center space-x-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onClick={() => setRating(star)}
                  className="focus:outline-none"
                >
                  <Star
                    className={`w-8 h-8 ${rating >= star
                        ? 'fill-yellow-400 text-yellow-400'
                        : 'text-gray-300'
                      }`}
                  />
                </button>
              ))}
            </div>

            <textarea
              placeholder="Any specific feedback? (optional)"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              rows={4}
            />

            <div className="flex space-x-3">
              <button
                onClick={handleClose}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Skip
              </button>
              <button
                onClick={handleFeedbackSubmit}
                disabled={rating === 0}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Submit
              </button>
            </div>
          </div>
        ) : (
          <div className="text-center py-8">
            <h2 className="text-2xl font-bold text-gray-900">Thank You! 🎉</h2>
            <p className="mt-2 text-gray-600">
              Your feedback helps us improve our service.
            </p>
            {rating === 5 && (
              <p className="mt-4 text-sm text-gray-600">
                Love it? Share with others!
              </p>
            )}
            <button
              onClick={handleClose}
              className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackModal;